import ViewerFragmentConfig from "@coworker/apprestructured/src/task-management/components/TaskViewerSheet/viewer-fragments/ViewerFragmentConfig";
import { reportMessageToSentry } from "@coworker/app/src/hooks/useConfigureSentry";
import TitledTextFieldViewerFragment from "@coworker/apprestructured/src/task-management/components/TaskViewerSheet/viewer-fragments/TitledTextFieldViewerFragment/TitledTextFieldViewerFragment";
import CompletableChecklistViewerFragment from "@coworker/apprestructured/src/task-management/components/TaskViewerSheet/viewer-fragments/CompletableChecklistViewerFragment/CompletableChecklistViewerFragment";
import UserNameViewerFragment from "@coworker/apprestructured/src/task-management/components/TaskViewerSheet/viewer-fragments/UserNameViewerFragment/UserNameViewerFragment";
import TitledBoxedTextViewerFragment from "@coworker/apprestructured/src/task-management/components/TaskViewerSheet/viewer-fragments/TitledBoxedTextViewerFragment/TitledBoxedTextViewerFragment";
import UserAndTeamViewerFragment from "@coworker/apprestructured/src/task-management/components/TaskViewerSheet/viewer-fragments/UserAndTeamViewerFragment/UserAndTeamViewerFragment";
import InvalidViewerFragment from "@coworker/apprestructured/src/task-management/components/TaskViewerSheet/viewer-fragments/InvalidViewerFragment/InvalidViewerFragment";
import { Loading } from "@coworker/apprestructured/src/task-management/loading";

export type ViewerFragmentCommonProps = {
  blockInput: boolean;
  task: Record<string, unknown> | Loading;
  onTaskChange: (part: Record<string, unknown>) => void;
};

type ViewerFragmentProps = {
  config: ViewerFragmentConfig;
  commonProps: ViewerFragmentCommonProps;
};

function ViewerFragment({ config, commonProps }: ViewerFragmentProps) {
  const { id, props: configProps } = config;
  switch (id) {
    case "titled-boxed-text-viewer-fragment": {
      return (
        <TitledBoxedTextViewerFragment
          configProps={configProps}
          commonProps={commonProps}
        />
      );
    }
    case "titled-text-field-viewer-fragment": {
      return (
        <TitledTextFieldViewerFragment
          configProps={configProps}
          commonProps={commonProps}
        />
      );
    }
    case "completable-checklist-viewer-fragment": {
      return (
        <CompletableChecklistViewerFragment
          configProps={configProps}
          commonProps={commonProps}
        />
      );
    }
    case "user-name-viewer-fragment": {
      return (
        <UserNameViewerFragment
          configProps={configProps}
          commonProps={commonProps}
        />
      );
    }
    case "user-and-team-viewer-fragment": {
      return (
        <UserAndTeamViewerFragment
          configProps={configProps}
          commonProps={commonProps}
        />
      );
    }
    default: {
      console.error(`'${id}' does not map to any viewer fragment component`);
      reportMessageToSentry(
        `Viewer fragment config id does not map to any viewer fragment component`,
        {
          id,
        },
        "error"
      );
      return <InvalidViewerFragment />;
    }
  }
}

export default ViewerFragment;
